export default __webpack_public_path__ + "static/media/brand.a1d315bd.png";